/* eslint-disable no-unused-vars */
import styled, { css } from 'styled-components';
import { Palette } from 'config';

export const HiddenInput = styled.div`
  display: none;
`;

export const Slice = styled.div`
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  opacity: 0;

  z-index: 5000;
`;

export const TodayBtnList = styled.ul`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 8px 24px 8px 0;
  cursor: default;
  gap: 1px;
`;

export const CalendarFoter = styled.div`
  display: flex;
  padding: 16px 24px;
`;

export const TodayButton = styled.button`
  height: 32px;
  padding: 6px 16px;
  cursor: pointer;
  color: ${Palette.PrimaryGray._700};
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  width: 113px;
  background: inherit;
  border: none;
  white-space: nowrap;
  text-align: left;
  background: #fff;
`;

export const EmptySpace = styled.div`
  height: 100%;
  background: #fff;
`;

export const ArrowWrap = styled.div`
  display: flex;
  align-items: center;
  margin: 0 8px;
  svg {
    fill: ${Palette.PrimaryGray._400};
  }
`;
